import isEmpty from 'lodash/isEmpty';
import { FieldError } from '@spike/model';
import Service from 'model/Service';
import { isNil } from 'lodash';

export const validateEvaluation = (service: Service): Array<FieldError> => {
    const errors: Array<FieldError> = [];

    if (isEmpty(service.evaluation?.category)) {
        errors.push({
            fieldName: 'category',
            errorMessage: 'Service category is required'
        });
    }

    if (isEmpty(service.name)) {
        errors.push({
            fieldName: 'name',
            errorMessage: 'Evaluation name is required'
        });
    }

    if (
        (service.duration.simple === undefined ||
            service.duration.simple.hours + service.duration.simple.minutes === 0) &&
        service.duration.variable.length === 0
    ) {
        errors.push({
            fieldName: 'duration',
            errorMessage: 'Duration is required'
        });
    }

    if (service.evaluation?.evaluationExpiry.enabled) {
        const duration = Number(service.evaluation?.evaluationExpiry.duration);
        if (!duration) {
            errors.push({
                fieldName: 'evaluationExpiry',
                errorMessage: 'Months is required'
            });
        } else if (duration < 1 || duration > 24) {
            errors.push({
                fieldName: 'evaluationExpiry',
                errorMessage: 'Months must be between 1 and 24'
            });
        }
    }

    service.pricing.fixedPrice?.map(price => {
        if (isNil(price.price)) {
            errors.push({
                fieldName: 'pricing',
                errorMessage: 'Price is Required'
            });
        }
    });

    if (service.evaluation?.evaluationQuestionsEnabled && service.evaluation?.evaluationQuestions?.length === 0) {
        errors.push({
            fieldName: 'questions',
            errorMessage: 'Questions is required'
        });
    }

    if (service.evaluation?.evaluationQuestionsEnabled) {
        service.evaluation.evaluationQuestions?.forEach((question, index) => {
            if (!question.questionText.trim()) {
                errors.push({
                    fieldName: `evaluationQuestions[${index}].questionText`,
                    errorMessage: 'Question text is required'
                });
            }

            if (question.questionText.length > 255) {
                errors.push({
                    fieldName: `evaluationQuestions[${index}].questionText`,
                    errorMessage: 'Question must be less than 255 characters'
                });
            }
        });
    }

    if (service.staff.length === 0) {
        errors.push({
            fieldName: 'staff',
            errorMessage: 'Staff Member in required'
        });
    }

    return [...errors];
};

export const getErrorMessage = (errors: Array<FieldError>, fieldName: string) => {
    if (!errors || errors.length === 0) {
        return '';
    }

    const errorObject = errors.find(error => error.fieldName === fieldName);

    return errorObject ? errorObject.errorMessage : '';
};

export const validateQuestionText = (questionText: string): string => {
    if (!questionText.trim()) {
        return 'Question text is required';
    }
    if (questionText.length > 255) {
        return 'Question must be less than 255 characters';
    }
    return '';
};

export const getQuestionError = (errors: Array<FieldError>, questionIndex: number): string => {
    const fieldName = `evaluationQuestions[${questionIndex}].questionText`;
    return getErrorMessage(errors, fieldName);
};

export const validateRequiredFields = (service: Service): boolean => {
    const errors = validateEvaluation(service);

    const requiredFields = ['category', 'name'] as const;
    const requiredPatterns = [/^evaluationQuestions\[\d+\]\.questionText$/];

    return errors.some(err => {
        const isRequiredField =
            requiredFields.includes(err.fieldName as any) || requiredPatterns.some(rx => rx.test(err.fieldName));

        return isRequiredField;
    });
};
